import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import { Title } from 'components/layout'
import { Input, Textarea, InputDate } from 'components/fields'

export default class AssessorWWC extends Component {
  static propTypes = {
    values: PropTypes.object,
    hideWWCFields: PropTypes.bool
  }

  static defaultProps = {
    values: {}
  }

  render() {
    const { values, hideWWCFields } = this.props

    const assessorWWC  = get(values, 'assessorWWC')

    const childProtectionNumber  = get(assessorWWC, 'childProtectionNumber')

    const childProtectionExpirationDate  = get(assessorWWC, 'childProtectionExpirationDate')

    return (
      <div>
        <Title h2 intlKey="moduleTitle.assessor_details">
          Assessor details
        </Title>
        <div className="row">
            <div className="col-xs-6">
                {!hideWWCFields && childProtectionNumber &&<Input
              label="WWC Number"
              intlKey="label.wwc_number"
              name="assessorWWC.childProtectionNumber"
            />}
          </div>

             <div className="col-xs-6">
                 {!hideWWCFields && childProtectionExpirationDate &&<InputDate
              label="Expiration date"
              intlKey="label.expiration_date"
              name="assessorWWC.childProtectionExpirationDate"
              allowPrevious={false}
            />}
          </div>

        </div>
        <div className="row">
          <div className="col-xs-12">
            <Textarea
              label="Qualifications"
              intlKey="label.qualifications"
              name="assessorWWC.qualification"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <Textarea
              label="Experience"
              intlKey="label.experience"
              name="assessorWWC.experience"
            />
          </div>
        </div>
      </div>
    )
  }
}
